import styled from "styled-components";
import { Description, ChartCard as BaseChartCard } from "./live-rdc";

export const StatsContainer = styled.div`
  margin-bottom: 2.4rem;
`;

export const Stats = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: -2.8rem;

  ${({ theme }) => theme.media.md`
    margin: -1.4rem;
  `}
`;

export const Stat = styled.div`
  width: 50%;
  padding: 2.8rem;

  ${({ theme }) => theme.media.md`
    width: 100%;
    padding: 1.4rem;
  `}
`;

export const StatHeader = styled.h2`
  font-weight: 600;
  font-size: 1.2rem;
  line-height: 1.6rem;
  text-transform: uppercase;
  color: #4b5563;
  margin-bottom: 0.2rem;

  ${({ theme }) => theme.media.sm`
    font-size: 1.3rem;
    line-height: 1.7rem;
  `}
`;

export const StatValue = styled.div`
  font-weight: 600;
  font-size: 4.8rem;
  line-height: 5.2rem;
  color: ${({ theme }) => theme.live.colors.primary};

  ${({ theme }) => theme.media.sm`
    font-size: 3.2rem;
    line-height: 3.5rem;
  `}
`;

export const StatTitle = styled.h3`
  font-weight: 600;
  font-size: 1.6rem;
  line-height: 2.2rem;
  color: #111827;
  margin-bottom: 1.5rem;

  ${({ theme }) => theme.media.sm`
    font-size: 1.7rem;
    line-height: 2.4rem;
  `}
`;

export const StatDescription = styled(Description)`
  margin: 0;
`;

export const Highlight = styled.span`
  color: ${({ theme }) => theme.live.colors.primary};
`;

export const ChartCard = styled(BaseChartCard)`
  margin: 2.4rem 0;
`;
